import DevPage from './DevPage'

export { DevPage }
export default DevPage
